import { instance } from "config/axiosInstance";

// note: declare base url
const baseURL = process.env.REACT_APP_TENANT_BE;

export async function getDepartment(pathname, queryParams = "") {
  return await instance({ baseURL: baseURL }).get(pathname + queryParams); // pathname is "/role"
}

export async function createDepartment(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/department" + pathname, body);
}

export async function updateDepartment(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).patch("/department" + pathname, body);
}

export async function deleteDepartment(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).delete("/department" + pathname, { data: body });
}
